import { Data } from '@blade/std-lib'

export class QuoteNotFoundError extends Data.TaggedError(
  'QuoteNotFoundError',
) {}
